import AppleMonoIcon from '@linktr.ee/arbor/app-icons/AppleMonoIcon';
import GoogleIcon from '@linktr.ee/arbor/app-icons/GoogleIcon';
import React from 'react';
import Button from './Button';

interface SocialButtonProps {
  provider: 'google' | 'apple';
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
  loading?: boolean;
}

const SocialButton: React.FC<SocialButtonProps> = ({
  provider,
  onClick,
  children,
  className = '',
  loading = false,
}) => {
  const getProviderIcon = () => {
    switch (provider) {
      case 'google':
        return <GoogleIcon />;
      case 'apple':
        return <AppleMonoIcon className="-translate-y-px" />;
      default:
        return null;
    }
  };

  const providerIcon = getProviderIcon();

  return (
    <Button
      onClick={onClick}
      label={children as string}
      icon={providerIcon || undefined}
      state={loading ? 'loading' : 'default'}
      className={className}
    />
  );
};

export default SocialButton;
